import React from 'react'
import { Checkbox, Popup } from 'util/ui'

import Link from 'redux-first-router-link'
import { SETTINGS_REPORTING_PAGE } from 'subapps/settings/types'
import styles from './styles.less'

export default class BusinessHoursControlView extends React.PureComponent {
  componentDidMount() {
    this.props.doBusinessHoursLoad()
  }
  render() {
    const {
      areAnyBusinessHoursSet,
      areBusinessHoursEnabled,
      doToggleBusinessHours,
    } = this.props
    return (
      <div>
        {areAnyBusinessHoursSet && (
          <Checkbox
            checked={areBusinessHoursEnabled}
            className={styles.DateControlView_Checkbox}
            label="Business Hours"
            onChange={doToggleBusinessHours}
          />
        )}
        {!areAnyBusinessHoursSet && (
          <Popup
            basic
            content={
              'You need to set your business hours before you can enable them.'
            }
            inverted
            on="hover"
            position="bottom center"
            trigger={
              <Checkbox
                checked={areBusinessHoursEnabled}
                className={styles.DateControlView_Checkbox}
                disabled
                label="Business Hours"
                onChange={doToggleBusinessHours}
              />
            }
          />
        )}
        <Link
          className={styles.link}
          to={{
            type: SETTINGS_REPORTING_PAGE,
            payload: { tab: 'business-hours' },
          }}
        >
          {`${areAnyBusinessHoursSet ? 'Edit' : 'Set'} hours`}
        </Link>
      </div>
    )
  }
}
